import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSubheader } from 'vuetify/lib/components/VSubheader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.loading
    ? _c(
        "div",
        [
          _c("auto-label-print", {
            ref: "autoLabelPrint",
            attrs: {
              "entry-mode":
                _vm.stage === 1 && _vm.localWorksheet.status === "PENDING",
              worksheet: _vm.localWorksheet,
              "product-info": _vm.productInfo,
            },
          }),
          _c("worksheet-header", {
            attrs: {
              worksheet: _vm.localWorksheet,
              worksheetTypeFields: _vm.worksheetTypeFields,
              sum: _vm.sum,
              productInfo: _vm.productInfo,
            },
            on: {
              "update:worksheet": function ($event) {
                _vm.localWorksheet = $event
              },
              "update:sum": function ($event) {
                _vm.sum = $event
              },
              jobUpdated: _vm.jobChanged,
            },
          }),
          _c("hr"),
          _vm.localWorksheet.status === "SUBMITTED" ||
          _vm.localWorksheet.status === "USED"
            ? _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c(
                    VAlert,
                    {
                      staticClass: "mb-7 text-center",
                      attrs: { outlined: "", color: "success" },
                    },
                    [
                      _vm.localWorksheet.status === "SUBMITTED"
                        ? _c("span", { staticClass: "my-auto" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$vuetify.lang.t(
                                    "$vuetify.worksheet.submittedOn"
                                  )
                                ) +
                                " " +
                                _vm._s(
                                  _vm._f("formatDateTime")(
                                    _vm.localWorksheet.submittedTime
                                  )
                                ) +
                                " "
                            ),
                          ])
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$vuetify.lang.t(
                                  "$vuetify.worksheet.worksheetUsed"
                                )
                              )
                            ),
                          ]),
                      _vm.isManagement &&
                      _vm.localWorksheet.status === "SUBMITTED"
                        ? _c(
                            VBtn,
                            {
                              staticClass: "ma-4",
                              attrs: { outlined: "" },
                              on: { click: _vm.toggleStatus },
                            },
                            [_vm._v(" Change Status ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            VFadeTransition,
            { attrs: { "hide-on-leave": "true" } },
            [
              _vm.stage === 0 && _vm.hasStage0
                ? _c("worksheet-settings", {
                    attrs: {
                      worksheet: _vm.localWorksheet,
                      worksheetTypeFields: _vm.worksheetTypeFields,
                      productInfo: _vm.productInfo,
                    },
                    on: {
                      onComplete: _vm.completePrerequisite,
                      "update:worksheet": [
                        _vm.handleWorksheetUpdate,
                        function ($event) {
                          _vm.localWorksheet = $event
                        },
                      ],
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            VFadeTransition,
            { attrs: { "hide-on-leave": "true" } },
            [
              _vm.stage === 1 && _vm.localWorksheet.status === "PENDING"
                ? _c("worksheet-entry", {
                    key: _vm.currentEntry.id || "new-entry",
                    attrs: {
                      worksheet: _vm.localWorksheet,
                      worksheetTypeFields: _vm.worksheetTypeFields,
                      sum: _vm.sum,
                      currentEntry: _vm.currentEntry,
                      productInfo: _vm.productInfo,
                    },
                    on: {
                      "add-entry": _vm.handleAddEntry,
                      "update-entry": _vm.handleUpdateEntry,
                      "update-entries": _vm.handleUpdateEntries,
                      "update:currentEntry": _vm.handleUpdateCurrentEntry,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(VDivider, { staticClass: "mt-4" }),
          _c("div", { staticClass: "d-flex justify-space-between" }, [
            _vm.localWorksheet.memo
              ? _c(
                  "div",
                  [
                    _c(VSubheader, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.base.memo")) +
                          ": "
                      ),
                      _c("div", { staticClass: "ml-2" }, [
                        _vm._v(" " + _vm._s(_vm.localWorksheet.memo) + " "),
                      ]),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            VBottomNavigation,
            { attrs: { grow: "", app: "" } },
            [
              (_vm.stage === 1 && _vm.hasStage0) ||
              (_vm.localWorksheet.status === "SUBMITTED" &&
                _vm.canEditSubmittedProcessTime)
                ? _c(
                    VBtn,
                    {
                      on: {
                        click: function ($event) {
                          _vm.stage = 0
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.base.settings"))
                        ),
                      ]),
                      _c(VIcon, [_vm._v("mdi-cog-outline")]),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.hasEntries
                ? _c(
                    VBtn,
                    { on: { click: _vm.deleteWorksheet } },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.base.delete"))
                        ),
                      ]),
                      _c(VIcon, { attrs: { color: "red" } }, [
                        _vm._v("mdi-trash-can"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.hasEntries
                ? _c(
                    VBtn,
                    {
                      on: {
                        click: function ($event) {
                          _vm.entriesDialog = true
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.groupedEntryCount) +
                            " " +
                            _vm._s(
                              _vm.$vuetify.lang.t("$vuetify.base.entries")
                            ) +
                            " "
                        ),
                      ]),
                      _c(VIcon, [_vm._v("mdi-format-list-numbered")]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.worksheetTypeFields.hasNotes
                ? _c(
                    VBtn,
                    {
                      on: {
                        click: function ($event) {
                          _vm.timestamp = Date.now()
                          _vm.notesDialog = true
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.base.notes"))
                        ),
                      ]),
                      _c(VIcon, [_vm._v("mdi-note-edit-outline")]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.stage === 0 && !_vm.submitted
                ? _c(
                    VBtn,
                    { on: { click: _vm.completePrerequisite } },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.base.entries"))
                        ),
                      ]),
                      _c(VIcon, [_vm._v("mdi-pencil-outline")]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.hasEntries && !_vm.submitted
                ? _c(
                    VBtn,
                    {
                      attrs: { disabled: _vm.loading },
                      on: { click: _vm.submitWorksheet },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.base.submit"))
                        ),
                      ]),
                      _c(VIcon, [_vm._v("mdi-arrow-up-circle-outline")]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            VDialog,
            {
              staticStyle: { "z-index": "1000" },
              attrs: { fullscreen: _vm.$vuetify.breakpoint.xsOnly },
              model: {
                value: _vm.entriesDialog,
                callback: function ($$v) {
                  _vm.entriesDialog = $$v
                },
                expression: "entriesDialog",
              },
            },
            [
              _c(
                VCard,
                [
                  _c(
                    VCardTitle,
                    { staticClass: "d-flex justify-end" },
                    [
                      _c(
                        VBtn,
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              _vm.entriesDialog = false
                            },
                          },
                        },
                        [_c(VIcon, [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCardText,
                    [
                      _c("worksheet-items", {
                        attrs: {
                          worksheet: _vm.localWorksheet,
                          sum: _vm.sum,
                          worksheetTypeFields: _vm.worksheetTypeFields,
                          productInfo: _vm.productInfo,
                          editable: true,
                        },
                        on: {
                          editEntry: _vm.editEntry,
                          deletedEntry: _vm.handleDeleteEntry,
                          reprintEntry: _vm.reprintEntry,
                          "refresh-worksheet": _vm.refreshWorksheet,
                          resolvedEntry: _vm.handleResolvedEntry,
                        },
                      }),
                      _vm.hasEntries &&
                      !_vm.isUsed &&
                      !_vm.isCancelled &&
                      _vm.hasInventoryEntries &&
                      _vm.worksheetTypeFields.hasInventorySelection &&
                      _vm.isFifoOrLifo
                        ? _c(
                            "div",
                            { staticClass: "d-flex justify-center mt-4" },
                            [
                              _c(
                                VBtn,
                                {
                                  attrs: { color: "warning", outlined: "" },
                                  on: { click: _vm.reassignAll },
                                },
                                [
                                  _c(VIcon, { attrs: { left: "" } }, [
                                    _vm._v("mdi-swap-horizontal"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$vuetify.lang.t(
                                          "$vuetify.worksheet.reassignAll"
                                        )
                                      ) +
                                      " "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VDialog,
            {
              staticStyle: { "z-index": "1000" },
              attrs: { fullscreen: _vm.$vuetify.breakpoint.xsOnly },
              model: {
                value: _vm.preSubmitDialog,
                callback: function ($$v) {
                  _vm.preSubmitDialog = $$v
                },
                expression: "preSubmitDialog",
              },
            },
            [
              _c(
                VCard,
                [
                  _c(
                    VCardTitle,
                    { staticClass: "d-flex justify-end" },
                    [
                      _c(
                        VBtn,
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              _vm.preSubmitDialog = false
                            },
                          },
                        },
                        [_c(VIcon, [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCardText,
                    [
                      _c("worksheet-entry-pre-submit", {
                        attrs: {
                          worksheet: _vm.localWorksheet,
                          sum: _vm.sum,
                          weightUnit: _vm.weightUnit,
                        },
                        on: {
                          "update:worksheet": function ($event) {
                            _vm.localWorksheet = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCardActions,
                    { staticClass: "d-flex justify-center" },
                    [
                      _c(
                        VBtn,
                        {
                          staticClass: "ma-8",
                          on: {
                            click: function ($event) {
                              _vm.preSubmitDialog = false
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$vuetify.lang.t("$vuetify.base.cancel")
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        VBtn,
                        {
                          staticClass: "ma-8",
                          attrs: { color: "primary" },
                          on: { click: _vm.submitWorksheet },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$vuetify.lang.t("$vuetify.base.submit")
                              ) +
                              " " +
                              _vm._s(
                                _vm.$vuetify.lang.t(
                                  "$vuetify.worksheet.worksheet"
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("worksheet-notes", {
            key: _vm.timestamp,
            attrs: { worksheet: _vm.localWorksheet },
            model: {
              value: _vm.notesDialog,
              callback: function ($$v) {
                _vm.notesDialog = $$v
              },
              expression: "notesDialog",
            },
          }),
          _c("confirmation-dialog", { ref: "confirm" }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }